<template lang="pug">
div
  v-dialog( v-model="loadingAsync" width="unset" :persistent="loadingAsync" )
    v-card
      v-card-title Синхронизация отчётов
      v-card-text( v-if="loadingAsync" )
        v-progress-linear( color="deep-purple accent-4" indeterminate rounded height="6" )

  router-view
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState('pointreport', ['loadingAsync'])
  }
}
</script>